import { render, staticRenderFns } from "./banner-list.vue?vue&type=template&id=3f1fbbca&scoped=true&"
import script from "./banner-list.vue?vue&type=script&lang=js&"
export * from "./banner-list.vue?vue&type=script&lang=js&"
import style0 from "./banner-list.vue?vue&type=style&index=0&id=3f1fbbca&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1fbbca",
  null
  
)

export default component.exports